import { render } from "./PaqueteProductosList.vue?vue&type=template&id=9430d7da&scoped=true"
import script from "./PaqueteProductosList.vue?vue&type=script&lang=js"
export * from "./PaqueteProductosList.vue?vue&type=script&lang=js"

import "./PaqueteProductosList.vue?vue&type=style&index=0&id=9430d7da&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9430d7da"]])

export default __exports__